/**
 * The feature name defined in the common package should be unique.
 Which means all features named in the other apps should be different from common package
 */


export enum FeatureNamespace {
    AUTHOR = 'author',
    COMMON = 'common',
    GRADING = 'grading',
    RUBRICS = 'rubrics',
}

export const featuresInCommon: string[] = ['workspaceDisabled'];

export const getFeatureNamespace = (featureName: string, appName: FeatureNamespace): FeatureNamespace => {
    if (featuresInCommon.includes(featureName)) {
        return FeatureNamespace.COMMON;
    }

    return appName;
};
